import { render, staticRenderFns } from "./SuspendReceiving.vue?vue&type=template&id=3bb1c2e5&scoped=true"
import script from "./SuspendReceiving.vue?vue&type=script&lang=js"
export * from "./SuspendReceiving.vue?vue&type=script&lang=js"
import style0 from "./SuspendReceiving.vue?vue&type=style&index=0&id=3bb1c2e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb1c2e5",
  null
  
)

export default component.exports